import { useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { MailCheck } from "lucide-react";
import Logo from "../components/Logo";
import { useLanguage } from "../context/LanguageContext";
import Field from "../components/Field";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ForgotPasswordPage() {
  const { t, lang } = useLanguage();
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const onSubmit = async (ev) => {
    ev.preventDefault();
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setError(t.errors.email);
      return;
    }
    setError("");
    setBusy(true);
    try {
      await axios.post(`${API}/auth/forgot-password`, { email, lang });
      setSent(true);
    } catch (e) {
      toast.error(t.errors.generic);
    } finally {
      setBusy(false);
    }
  };

  return (
    <main data-testid="forgot-password-page" className="pt-[72px] min-h-screen flex items-center justify-center px-5 py-16">
      <div className="w-full max-w-md rounded-2xl border border-white/10 bg-[#0F1015] p-8 lg:p-10">
        <div className="flex justify-center"><Logo /></div>
        <h1 className="mt-8 text-center font-display text-xl font-bold uppercase">{t.auth.forgotTitle}</h1>

        {sent ? (
          <div data-testid="forgot-success" className="mt-6 text-center">
            <MailCheck size={36} className="mx-auto text-gold" />
            <p className="mt-4 text-sm text-slate-300 leading-relaxed">{t.auth.forgotSent}</p>
            <Link to="/auth" data-testid="forgot-back-login" className="btn-outline mt-7 inline-flex text-[11px] font-mono2 uppercase">
              {t.auth.backToLogin}
            </Link>
          </div>
        ) : (
          <>
            <p className="mt-2 text-center text-sm text-slate-400">{t.auth.forgotSub}</p>
            <form className="mt-7 space-y-5" data-testid="forgot-password-form" onSubmit={onSubmit} noValidate>
              <Field id="forgot-email" label={t.auth.email} error={error} required>
                <input
                  id="forgot-email"
                  data-testid="forgot-email-input"
                  type="email"
                  className={`field-input ${error ? "has-error" : ""}`}
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  autoComplete="email"
                />
              </Field>
              <button type="submit" data-testid="forgot-submit-button" disabled={busy} className="btn-gold w-full text-xs font-mono2 uppercase disabled:opacity-60">
                {busy ? "…" : t.auth.forgotBtn}
              </button>
            </form>
            <Link to="/auth" data-testid="forgot-back-login-link" className="mt-6 block text-center font-mono2 text-[11px] uppercase text-slate-400 hover:text-gold-soft transition-colors">
              {t.auth.backToLogin}
            </Link>
          </>
        )}
      </div>
    </main>
  );
}
